<template>
    <ul
        tabindex="0"
        class="dropdown-content menu min-w-56">
        <template v-if="options.length">
            <li
                v-for="(item, index) in options"
                :key="index"
                class="rounded"
                @click="handleClickItem(item || '')">
                <template v-if="item.children">
                    <details>
                        <summary
                            class="mb-2"
                            :class="item.class">
                            <span>
                                {{ item[labelKey] || '...' }}

                                <hts-tooltip
                                    v-if="item[labelTooltip]"
                                    class="float-right">
                                    <div>
                                        <span class="font-bold">
                                            {{ item[labelTooltip] }}
                                        </span>
                                    </div>
                                    <template #reference>
                                        <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                    </template>
                                </hts-tooltip>
                            </span>
                        </summary>
                        <recursive-component
                            :options="item.children"
                            :value-key="valueKey"
                            :icon-key="iconKey"
                            :handle-action="handleAction"
                            :is-dropdown="false" />
                    </details>
                </template>
                <a v-else>
                    <slot :item="item">
                        <div
                            class="flex py-0"
                            :class="item.class">
                            <component
                                :is="item[iconKey]"
                                v-if="item[iconKey]"
                                class="icon w-6 h-6" />
                            <span class="p-0">
                                {{ item[labelKey] || '...' }}
                            </span>
                        </div>
                    </slot>
                </a>
            </li>
        </template>
        <template v-else>
            <li>
                <a>
                    No data
                </a>
            </li>
        </template>
    </ul>
</template>
<script setup lang="ts">
import RecursiveComponent from './item.vue'

const props = defineProps({
  options: {
    type: Array,
    required: true
  },
  valueKey: {
    type: String,
    default: 'value'
  },
  labelKey: {
    type: String,
    default: 'label'
  },
  labelTooltip: {
    type: String,
    default: 'tooltip'
  },
  iconKey: {
    type: String,
    default: 'icon'
  },
  handleAction: {
    type: Function,
    required: true
  }
})

const handleClickItem = (item: any) => {
  if (item?.children) {
    return
  }
  props.handleAction(item)
}
</script>
